import { defineComponent as _defineComponent } from 'vue'
import useFormattedDateTime from '@/mixins/useFormattedDateTime';


export default /*#__PURE__*/_defineComponent({
  __name: 'MeetingSlotLabel',
  props: {
    start: null,
    end: null
  },
  setup(__props: any) {



const { getFormattedDate, getFormattedTimeRange } = useFormattedDateTime();

return { __sfc: true,getFormattedDate, getFormattedTimeRange }
}

})